define(() => {
    "use strict";

    return {
        GROUP: "GROUP",
        EXPERIENCE: "EXPERIENCE"
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/SharedEntityType.js